const ContactCard = ({ icon, title, description, link, items, linkPrefix }) => {
    const Body = (
        <div className="flex flex-col items-center text-center space-y-4">
            <div className="w-16 h-16 bg-brand-50 rounded-full flex items-center justify-center gh:bg-brand-500 transition-colors duration-300">
                <img src={icon} alt={title} className="w-8 h-8 gh:invert transition-all" />
            </div>
            <div>
                <h5 className="font-bold text-gray-900 text-lg mb-1 uppercase tracking-tight">{title}</h5>
                {items?.length ? (
                    <div className="flex flex-col gap-1">
                        {items.map((item) => (
                            <a
                                key={item}
                                href={`${linkPrefix}${item}`}
                                target="_blank"
                                rel="noreferrer"
                                className="text-gray-500 text-sm leading-relaxed hover:text-brand-500 transition-colors"
                            >
                                {item}
                            </a>
                        ))}
                    </div>
                ) : (
                    <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
                )}
            </div>
        </div>
    );

    const Card = (
        <div className="group h-full p-6 bg-white border border-gray-100 rounded-2xl shadow-sm ha:shadow-md transition-all duration-300 ha:-translate-y-1">
            {Body}
        </div>
    );

    return link ? (
        <a href={link} target="_blank" rel="noreferrer" className="block h-full">
            {Card}
        </a>
    ) : Card;
};

export default ContactCard;